import { useLang } from "@/i18n/LanguageContext";

export const LanguageToggle = ({ className = "" }) => {
  const { lang, setLang } = useLang();
  const langs = ["en", "da"];
  return (
    <div
      className={`inline-flex items-center rounded-full border border-[var(--line-strong)] bg-white/[0.04] p-0.5 ${className}`}
      data-testid="language-toggle"
    >
      {langs.map((l) => (
        <button
          key={l}
          type="button"
          onClick={() => setLang(l)}
          aria-pressed={lang === l}
          data-testid={`lang-${l}`}
          className={`px-2.5 py-1 rounded-full text-xs font-mono uppercase tracking-wider transition-colors duration-300 ${
            lang === l ? "bg-[var(--blue)] text-white" : "text-muted hover:text-white"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
};
